import React, { useEffect, useMemo, useState } from 'react';
// import { GoatSubmitAnimation } from './goatAnimation';

import { GoatAnimationCanvas } from './goatAnimationCanvas';

const MESSAGE_INTERVAL_MS = 3500;

export function SubmissionProgress({ step }) {
  const pct = step ? Math.max(0, Math.min(100, Number(step.progress) || 0)) : 0;
  const messages = step?.messages;
  const isComplete = Boolean(step?.label);

  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    if (!messages?.length || isComplete) return undefined;

    setMessageIndex(0);
    const intervalId = setInterval(() => {
      setMessageIndex((index) => (index + 1) % messages.length);
    }, MESSAGE_INTERVAL_MS);

    return () => clearInterval(intervalId);
  }, [messages, isComplete]);

  const displayLabel = isComplete
    ? step.label
    : messages?.[messageIndex] ?? messages?.[0] ?? '';

  // If progress hasn't moved recently, show an indeterminate animation so the UI
  // still feels active during slow network calls.
  const [isStalled, setIsStalled] = useState(false);
  useEffect(() => {
    if (!step) return undefined;

    setIsStalled(false);
    const t = setTimeout(() => setIsStalled(true), 900);
    return () => clearTimeout(t);
  }, [step, displayLabel, pct]);

  const progressStyle = useMemo(() => {
    if (isStalled) {
      return {
        height: '100%',
        width: '100%',
        background:
          'linear-gradient(90deg, rgba(47,115,79,0.45) 0%, rgba(47,115,79,1) 50%, rgba(47,115,79,0.45) 100%)',
        backgroundSize: '200% 100%',
        animation: 'wg-progress-indeterminate 1.2s ease-in-out infinite',
      };
    }

    return {
      height: '100%',
      width: `${pct}%`,
      background: 'var(--border-color)',
      borderRadius: 4,
      transition: 'width 0.5s ease',
    };
  }, [isStalled, pct]);

  if (!step) return null;

  return (
    <div
      className="submission-progress"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(255,255,255,0.89)',
        zIndex: 99,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        // backdropFilter: 'blur(3px)',
      }}
      aria-live="polite"
      aria-label="Submitting quote"
    >
      <style>{`
        @keyframes wg-progress-indeterminate {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      `}</style>
      <div
        className="submission-progress-content"
        style={{ width: '100%', maxWidth: 520, padding: '0 1.5rem', textAlign: 'center' }}
      >
        <p
          className="submission-progress-content-label"
          style={{ marginBottom: '1rem', fontWeight: 600, fontSize: '1.1rem', lineHeight: '1.3' }}
        >
          {displayLabel}
        </p>
        <div
          className="submission-progress-bar"
          style={{
            height: '8px',
            borderRadius: '4px',
            background: 'var(--border-color)',
            overflow: 'hidden',
          }}
        >
          <div
            className="submission-progress-bar-progress"
            style={progressStyle}
          />
        </div>

        <GoatAnimationCanvas celebrate={isComplete} />
      </div>
    </div>
  );
}
